import * as React from 'react';
import numeral from 'numeral';

import { ZoneSelectProps } from '../../components/cart/zone-select';
import { IZone } from '../../custom/classes/production';
import { sumPrices } from '../../helpers/pricing-helpers';

const ZoneSelectView: React.StatelessComponent<ZoneSelectProps> = props => {

    function onChange(evt: React.ChangeEvent<HTMLSelectElement>) {
        const selectedValue = +evt.currentTarget.value;
        props.selectZone(props.itemId, selectedValue);
    }

    function decodeHtmlEntities(text: string): string {
        const textarea = document.createElement('textarea');
        textarea.innerHTML = text;
        return textarea.value;
    }


    return (
        <div className="space-top-sm">
            {
                props.selectedZone == null && props.venueZoneMapImageUrl != null ?
                    <div className="ace-flex-zone-map"><img src={props.venueZoneMapImageUrl} alt={`${props.venueName} zone map`} /></div>
                    : null
            }

            <div>
                {
                    props.requiresPriceTypeSelection ?
                        (
                            props.showPriceTypeError
                                ?
                                <p className="error-message">
                                    <a href="#quantitySelect">
                                        {props.missingPriceTypeSelectionMessage}
                                    </a>
                                </p>
                                : null)
                        :
                        (
                            props.selectedZone != null ?
                                <div className="flex-between">
                                    <span className="bold">{decodeHtmlEntities(props.selectedZone.zone.description)}</span>
                                    <span>{numeral(sumPrices(props.selectedZone, props.selectedPriceTypeQuantities,
                                        props.pwycAmounts, props.itemId, props.pwycSettings).priceSum).format('$0,0.00')}</span>
                                </div>
                                :
                                (
                                    !props.hideZoneDropdown &&
                                    <div className="stack-xs">
                                        <label htmlFor={props.itemId + "-quantity"}>
                                            {props.selectAZoneLabel}
                                        </label>
                                        <select name={props.itemId + "-quantity"} id={props.itemId + "-quantity"} onChange={(evt) => {
                                            onChange(evt);
                                        }} value={props.selectedZone?.zone.id ?? 0}>
                                            <option key={0} value={0}>
                                                {props.selectAZoneDropdownDefaultValue}
                                            </option>
                                            {
                                                props.zones.sort((a, b) => { return a.zone.rank - b.zone.rank; }).map(zone => {
                                                    let { priceSum, foundAllPriceTypes } = sumPrices(zone, props.selectedPriceTypeQuantities);

                                                    const price = numeral(priceSum).format('$0,0.00');

                                                    const optionDisabled = !(zone.availableCount > Array.from(props.selectedPriceTypeQuantities.values()).reduce((total, num) => total + num, 0) && foundAllPriceTypes);

                                                    // AAC26-75 - Show PWYC zone description for eligible PWYC zones
                                                    // Must match both zone AND price type lists when both are specified
                                                    const isZoneInList = props.pwycZoneIds.length === 0 || props.pwycZoneIds.indexOf(zone.zone.id) >= 0;
                                                    const hasEligiblePriceType = props.pwycPriceTypeIds.length === 0
                                                        || zone.prices.some(p => props.pwycPriceTypeIds.indexOf(p.priceTypeId) >= 0);
                                                    const isZonePwyc = props.isPwyc && isZoneInList && hasEligiblePriceType;

                                                    let optionDisplay: string;
                                                    if (isZonePwyc && props.zoneDropdownDescription) {
                                                        const zoneMinPrice = zone.prices.length > 0
                                                            ? Math.min(...zone.prices.map(p => p.price)) : 0;
                                                        const pwycDescription = props.zoneDropdownDescription.indexOf('{0}') >= 0
                                                            ? props.zoneDropdownDescription.replace('{0}', numeral(zoneMinPrice).format('$0,0.00'))
                                                            : props.zoneDropdownDescription;
                                                        optionDisplay = `${decodeHtmlEntities(zone.zone.description)} - ${optionDisabled ? "Not Available" : pwycDescription}`;
                                                    } else {
                                                        optionDisplay = `${decodeHtmlEntities(zone.zone.description)} - ${optionDisabled ? "Not Available" : price}`;
                                                    }

                                                    return (<option disabled={optionDisabled} key={zone.zone.id} value={zone.zone.id}>{optionDisplay}</option>)
                                                })
                                            }
                                        </select>
                                    </div>
                                )
                        )
                }
            </div>
        </div>
    );
}

export default ZoneSelectView;


